<template>
    <!-- modal-xl -->
    <b-modal id="affidavitValidationModal" size="xxl" title="Affidavit Validation" title-class="font-18" hide-footer @hide="onHide">
        <div class="row row-container">
            <div class="left-pane">
                <h4 class="mb-3">{{ this.selected_supplier_certificate.company_name }}</h4>
                <h5>Validation Checks:</h5>
                <div class="group-of-actions">
                    <h6 class="ml-1">
                        Legislation
                    </h6>
                    <CertificateValidationQuestions />
                </div>

                <div class="group-of-actions">
                    <b-form-group label="Notes:" label-for="textarea-formatter" class="">
                        <b-form-textarea v-model="this.notes" id="textarea-formatter" placeholder="Editable"></b-form-textarea>
                    </b-form-group>
                </div>

                <div class="group-of-actions d-flex justify-content-center">
                    <!-- <b-button variant="primary" type="button" class="btn btn-primary m-1 ">
                        Upload Affidavit
                    </b-button> -->

                    <!-- <b-button @click="newWindow" variant="primary" class="btn btn-primary m-1">
                        <i class="mdi mdi-dock-window mr-1"></i>
                        View</b-button
                    > -->

                    <!-- {{ current_active_legislation }} {{ new_selected_legislation }} -->
                    <b-button
                        v-if="current_active_legislation != new_selected_legislation"
                        @click="updateChecks"
                        variant="primary"
                        class="btn btn-primary m-1"
                        >Update Checks</b-button
                    >

                    <!-- <div class="group-of-actions d-flex "> -->
                        <b-button @click="newWindow" variant="primary" type="button" class="btn btn-primary m-1">
                            <i class="mdi mdi-dock-window mr-1"></i> View
                        </b-button>

                    <b-button
                        v-if="current_active_legislation == new_selected_legislation && affidavit_checks_changed.length > 0"
                        @click="save"
                        variant="primary"
                        class="btn btn-primary  m-1"
                        >Save</b-button
                    >
                </div>
            </div>

            <div class="right-pane">
                <!-- <div>
                    <b-button @click="newWindow" variant="primary" class="btn btn-primary float-right mb-2">
                        <i class="mdi mdi-dock-window mr-1"></i>
                        View</b-button
                    >
                </div> -->
                <!-- <embed src="example-pdf.pdf#page=1&zoom=50&toolbar=0" class="w-100 h-100" /> -->
                <embed :src="selectedFile" class="w-100 h-100" />
            </div>
        </div>

        <div class="modal-footer mt-3">
            <b-button variant="primary" type="button" class="btn btn-primary" @click="goBack">
                Back
            </b-button>
            <b-button variant="primary" type="button" class="btn btn-primary" @click="closeModal">
                Close
            </b-button>
        </div>
    </b-modal>
</template>

<script>
//eslint-disable-next-line
import Swal from "sweetalert2";
import { adminComputed, suppliersComputed, certificateValidationComputed, certificateValidationMethods } from "../../state/helpers";
import CertificateValidationQuestions from "./certificateValidationQuestions.vue";

export default {
    components: { CertificateValidationQuestions },
    data: () => ({
        notes: "",
        selected_legislation: null,
        selected_conf: null,
        selectedFile: ""
    }),
    computed: {
        ...adminComputed,
        ...suppliersComputed,
        ...certificateValidationComputed,
        legislation_options() {
            return [
                { value: null, text: "Please select an option", disabled: true },
                { value: 1, text: "legislation: 1 Sep 2022 - current" },
                { value: 2, text: "legislation: 1 Jan 2022 - 30 AUg 2022 " },
            ];
        },
        confirmation_options() {
            return [
                { value: null, text: "Select:", disabled: true },
                { value: "1-1", text: "yes" },
                { value: 2, text: "no" },
                { value: 3, text: "n/a" },
            ];
        },
    },
    methods: {
        ...certificateValidationMethods,
        onHide(evt) {
            if (evt.trigger === "backdrop") {
                //eslint-disable-next-line
                console.log("backdrop was clicked");
                this.setAffidavitChecksChanged(-1);
            }
        },
        closeModal() {
            this.setAffidavitChecksChanged(-1); // will reset back to empty []
            this.$bvModal.hide("affidavitValidationModal");
            this.$emit("setModalFalse", "affidavitValidationModal");
        },
        goBack() {
            this.$emit("handleModal", "certificateEditModal");
            this.closeModal();
        },
        newWindow() {
            window.open(this.selectedFile, "_blank");
        },
        save() {
            //eslint-disable-next-line
            let id;

            if (this.new_selected_legislation != null) {
                id = this.new_selected_legislation;
            } else {
                id = this.current_active_legislation;
            }

            Swal.fire({
                title: `Save check answers?`,
                text: `Are you sure you would like to save the check answers? `,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Confirm",
            }).then((result) => {
                if (result.value) {
                    this.saveCertificateValidationAnswer({
                        certificate_id: this.selected_supplier_certificate.id,
                        regulation_version_id: id,
                        capture_user_id: this.client_id,
                        answers: this.affidavit_checks_changed,
                        notes: this.notes,
                    }).then(() => {
                        //eslint-disable-next-line
                        Swal.fire("Updated", "Checks updated", "success");
                        // this resets the the state so that the checks are empty
                        this.setAffidavitChecksChanged(-1);
                    });
                }
            });
        },
        updateChecks() {
            if (this.current_active_legislation != this.new_selected_legislation) {
                //eslint-disable-next-line
                Swal.fire({
                    title: `Change legislation period?`,
                    text: `Are you sure you would like to change the lesgislation period? `,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Confirm",
                }).then((result) => {
                    if (result.value) {
                        //eslint-disable-next-line
                        this.setActiveCertificateRegulationVersion({
                            certificate_id: this.selected_supplier_certificate.id,
                            regulation_version_id: this.new_selected_legislation,
                        }).then(() => {
                            //eslint-disable-next-line
                            Swal.fire("Updated", "Active Certificate Regulation ", "success");

                            //re-populate the store
                            this.setRegulationVersions({ certificate_id: this.selected_supplier_certificate.id });
                            this.setValidationChecksByCertificate({
                                certificate_id: this.selected_supplier_certificate.id,
                                regulation_version_id: -1,
                            });
                        });
                    }
                });
            }
        },        
    },
    mounted() {
        // NB this resets it on first load
        this.setNewSelectedLegislation(this.current_active_legislation);
        this.selectedFile = this.selected_supplier_certificate.certificate_src + "#page=1&zoom=75&toolbar=0";                
        // alert("aff");
    },
};
</script>

<style lang="scss" scoped>
//   the default style attached to modal footer  border-top: 1px solid #eff2f7;
.align-text-setting {
    text-align: right;
}
.height {
    min-height: 500px;
}

// this makes the left and right pane in the flex
.row-container {
    display: flex;
    padding: 10px;
}

.left-pane {
    width: 40%;

    .b-form-group {
        margin-right: 50px;
    }
    .b-form-input {
        max-width: 100%;
    }
}
.group-of-actions {
    border-top: 1px solid #eff2f7 !important;
    margin-top: 25px;
    padding-top: 15px;
    margin-right: 25px;
}

.button-width {
    width: 200px;
}

.right-pane {
    width: 60%;
    display: flex;
    flex-direction: column;
}

// the purpose of this media query is simply to make the contents of modal display flex-column
// and then for the panes to have a width off 100% instead of 50%
@media only screen and (max-width: 990px) {
    .align-text-setting {
        text-align: left;
    }
    .row-container {
        flex-direction: column;
    }

    .left-pane {
        width: 100%;
    }

    .right-pane {
        width: 100%;
        margin-top: 25px;
        height: 350px;
    }
}

.select-width {
    width: 80px;
    max-width: 80px;
}
// TODO: not used
.group-max-height {
    max-height: 300px;
    overflow: scroll;
}
.modal-xxl {
    width: 100%;
    max-width: 1350px;
}
</style>
